export const addWatermark = (imageDataURL) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        return reject(new Error("Failed to get canvas 2D context"));
      }

      const img = new window.Image();
      img.src = imageDataURL;

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        // Calculate font size based on image dimensions
        const fontSize = Math.min(canvas.width, canvas.height) * 0.1; // 10% of smallest dimension
        ctx.font = `${fontSize}px Arial`;
        ctx.fillStyle = "rgba(128, 128, 128, 0.5)"; // Semi-transparent gray
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const watermarkText = "Gharwalah.com";
        
        // Position watermark in center
        const x = canvas.width / 2;
        const y = canvas.height / 2;
        
        ctx.fillText(watermarkText, x, y);

        const watermarkedImage = canvas.toDataURL();
        resolve(watermarkedImage);
      };

      img.onerror = () => {
        reject(new Error("Failed to load image for watermarking"));
      };
    });
  };
